export enum DocumentType {
    HEALTHCARE = 'HEALTHCARE',
    EMPLOYMENT = 'EMPLOYMENT'
}
